import { render } from "./controls.vue?vue&type=template&id=e33a73f4"
import script from "./controls.vue?vue&type=script&lang=js"
export * from "./controls.vue?vue&type=script&lang=js"

import exportComponent from "/home/vn_samvida_szbdnulkh/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__